import { ReactNode } from 'react';
import { Box, Stack, Typography, useTheme } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { getChartColors } from './styles';

type CustomLegendProps = {
  primarySeries: ReactNode;
  secondarySeries?: ReactNode;
  tertiarySeries?: ReactNode;
};

const renderSeriesLegend = (node: ReactNode) =>
  typeof node === 'string' ? (
    <Typography variant="body2" color="textSecondary">
      {node}
    </Typography>
  ) : (
    node
  );

export const CustomLegend = ({
  primarySeries,
  secondarySeries,
  tertiarySeries,
}: CustomLegendProps) => {
  const theme = useTheme();
  const { primary, secondary } = getChartColors(theme);

  return (
    <Stack direction="row" spacing={2} sx={{ py: 1 }} useFlexGap>
      <Stack
        direction="row"
        sx={{ alignItems: 'center' }}
        spacing={1}
        useFlexGap
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: borderRadius('xl'),
            backgroundColor: primary,
          }}
        />
        {renderSeriesLegend(primarySeries)}
      </Stack>
      {secondarySeries && (
        <Stack direction="row" alignItems="center" spacing={1} useFlexGap>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: borderRadius('xl'),
              backgroundColor: secondary,
            }}
          />
          {renderSeriesLegend(secondarySeries)}
        </Stack>
      )}
      {tertiarySeries && (
        <Stack direction="row" alignItems="center" spacing={1} useFlexGap>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: borderRadius('xl'),
              backgroundColor: t => t.palette.background.paper,
              border: `1px solid ${primary}`,
            }}
          />
          {renderSeriesLegend(tertiarySeries)}
        </Stack>
      )}
    </Stack>
  );
};
